import { abmTripsLayerName } from "@/services/deck.service";

export default {
  getAbmData(state, getters, rootState) {
    const deckLayer = rootState.map?.getLayer(abmTripsLayerName);
    const impl = deckLayer?.implementation ?? deckLayer;
    return impl?.props?.data;
  },
};
